import React, { Dispatch, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CAppInfoTooltip from '../../../../app/components/CAppInfoTooltip';
import CAppSubTitle from '../../../../app/components/CAppSubTitle';
import AppCustomIcon from '../../../../app/features/icon/AppIcon';
import investmentDisclaimerLang from '../../langs/investmentDisclaimerLang';
import IFund from '../../interfaces/fund/IFund';
import IFundFilters from '../../interfaces/fund/IFundFilters';
import investmentFundLang from '../../langs/investmentFundLang';
import AppLoaderContent from '../../../../app/features/loader/content/AppLoaderContent';
import VInvestFundPerformancePrivateCredit from './VInvestFundPerformancePrivateCredit';
import VInvestFundPerformanceVentureCapital from './VInvestFundPerformanceVentureCapital';
import VInvestFundPerformancePrivateEquity from './VInvestFundPerformancePrivateEquity';
import VInvestFundPerformanceListedAssets from './VInvestFundPerformanceListedAssets';

type VInvestFundPerformanceProps = {
	fund: IFund;
	filters: IFundFilters;
	setDataUpdatedOn: Dispatch<Date>;
};

const VInvestFundPerformance = (props: VInvestFundPerformanceProps) => {
	const { fund, filters, setDataUpdatedOn } = props;

	const { t } = useTranslation();

	const [expertiseTag, setExpertiseTag] = useState<string | null>(null);
	useEffect(() => {
		if (fund && fund.typeTag) {
			setExpertiseTag(fund.typeTag);
		}
	}, [fund]);

	return (
		<>
			<CAppSubTitle
				title={t(investmentFundLang.title_performance.tag)}
				subtitle={<CAppInfoTooltip title={t(investmentDisclaimerLang.info_tooltip.tag)} />}
				icon={<AppCustomIcon tag="pie_chart" className="icon" />}
			/>
			{expertiseTag ? (
				<>
					{expertiseTag === 'private_credit' ? (
						<VInvestFundPerformancePrivateCredit
							fund={fund}
							filters={filters}
							setDataUpdatedOn={setDataUpdatedOn}
						/>
					) : expertiseTag === 'venture_capital' ? (
						<VInvestFundPerformanceVentureCapital
							fund={fund}
							filters={filters}
							setDataUpdatedOn={setDataUpdatedOn}
						/>
					) : expertiseTag === 'private_equity' ? (
						<VInvestFundPerformancePrivateEquity
							fund={fund}
							filters={filters}
							setDataUpdatedOn={setDataUpdatedOn}
						/>
					) : expertiseTag === 'listed_assets' ? (
						<VInvestFundPerformanceListedAssets fund={fund} setDataUpdatedOn={setDataUpdatedOn} />
					) : (
						<>{expertiseTag}</>
					)}
				</>
			) : (
				<AppLoaderContent />
			)}
		</>
	);
};

export default VInvestFundPerformance;
